// extracted by mini-css-extract-plugin
export default {"floatVideoCard":"index_floatVideoCard__tHLbH","dragging":"index_dragging__5Yq0D","videoCardIcon":"index_videoCardIcon__Ff-p1"};